import React, {useEffect, useState, memo, useCallback} from 'react';
import {    
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Avatar,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent, 
    Divider,
    Grid,
    IconButton,
    LinearProgress,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import { 
    AccountBalance as AccountBalanceIcon,
    AddCircleOutline as AddCircleOutlineIcon,
    Apartment as ApartmentIcon,
    Close as CloseIcon,
    Delete as DeleteIcon,
    Drafts as DraftsIcon,
    ExpandMore as ExpandMoreIcon,
    ImportantDevices as ImportantDevicesIcon,
    LabelImportant as LabelImportantIcon,
    MarkunreadMailbox as MarkunreadMailboxIcon,
    Palette as PaletteIcon,
    Edit as EditIcon,
    Save as SaveIcon,
    Wallpaper as WallpaperIcon,
} from '@material-ui/icons';
import { red } from '@material-ui/core/colors';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import { SnackbarProvider, useSnackbar } from 'notistack';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import FacebookCircularProgress from '../../Elementos/FacebookCircularProgress';
import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { 
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';
import Alert from '@material-ui/lab/Alert';
import ImageUploading from 'react-images-uploading';

const TrYounetStyled = styled.tr`
    display:flex;
    z-index:2;
    background-color:${props => props.selected ? 'LightBlue' : '#fff'};
    &:hover{
        background-color:Gainsboro
    }
`;

const TdYounetStyled = styled.td`
    color:${props => props.color ? props.color : 'black'};
    font-size:${props => props.fontSize ?  props.fontSize : '10px'};
    font-weight:${props => props.bolder ? 'bold' : 'none'};
    min-width:${props => props.minWidth || 100};
    width:${props => props.width || 100};
    padding-top:${props => props.element ? '0px' : '5px'}; 
    text-align:${props => props.align ? props.align : 'left'};
    background:transparent;
    border-bottom: 1px solid #E5E8E8;
    display:block;
    height:40px;
    max-height:40px;
    padding:8px;   
    position:relative;
    left:0px;      
    text-overflow: ellipsis;    
    white-space: nowrap; 
    overflow: hidden;
    line-height:25px;
`;

const TheadYounetStyled = styled.th`
    text-align:${props => props.align ? props.align : 'left'};
    min-width:${props => props.width || 60};
    width:${props => props.width || 100};
    background-color:#0E3B5F;
    color: #fff;
    display:block;
    font-weight:bold, 
    height:33px;
    max-height:33px;
    padding-left:10px;
    padding-top:6px;
    position: relative;
    left:0px;   
`;

const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
    <TheadYounetStyled width={widthDefault} align={align}>
        <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : 'asc'}
            onClick={createSortHandler(headCell.id)} 
            style={{color:'#fff', textAlign:align}}
        >
            {headCell.label}
            {orderBy === headCell.id ? (
            <span className={classes.visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
            </span>
            ) : null}
        </TableSortLabel>
    </TheadYounetStyled>
));

const columns = [
    { id: 'Action', label: 'Action', minWidth: 100,numeric: false, disablePadding: false },
    { id: 'Empresa', label: 'Empresa', minWidth: 140,numeric: false, disablePadding: false },
    { id: 'Ruc', label: 'Ruc', minWidth: 140,numeric: false, disablePadding: false },
    { id: 'Telefono', label: 'Telefono', minWidth: 150,numeric: false, disablePadding: false },
    { id: 'Direccion', label: 'Direccion', minWidth: 225, numeric: false, disablePadding: false },
    { id: 'EmailAdministrador', label: 'Email Admin.', minWidth: 190, numeric: false, disablePadding: false },
    { id: 'PaginaWeb', label: 'Pagina Web', minWidth: 190, numeric: false, disablePadding: false}, 
    { id: 'EmailSoporte', label: 'Email Soporte', minWidth: 190, numeric: false, disablePadding: false}, 
    { id: 'EmailInfo', label: 'Email Info', minWidth: 190, numeric: true, disablePadding: false}, 
];

const styles2 = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: red[900],
    },
});

const DialogTitle = withStyles(styles2)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
});

const styles = makeStyles((theme)=>({
    paper:{
        padding:20
    },
    button:{
        color:'#fff'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    secondaryHeading: {
        marginTop:6,
        marginLeft:5,
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

const RowEmpresa = ({rowInfo, handleDelete, handleUpdate })=>{
    const classes = styles();
    const { enqueueSnackbar } = useSnackbar();
    const [ openDialog, setOpenDialog ] = useState(false);  
    const [ isContinuoEdit, setContinuoEdit ] = useState(false);
    const [ openDialogEditInformacion, setOpenDialogEditInformacion ] = useState(false);
    const [ Datos, setDatos ] = useState({ 
        Direccion:'',
        EmailAdministrador:'',
        EmailFactura:'',
        EmailHost:'',
        EmailNotificaciones:'',
        EmailSoporte:'',
        EmailSSL:false,
        Empresa:'',
        Ruc:'',
        Telefono:''
    });
    const [ isProcessing, setProcessing ] = useState(false);
    const [ expanded, setExpanded ] = useState(false);
    const [ arrBancos, setArrBancos ] = useState([{ Banco:'', Tipo:'', Cuenta:'', idBanco:Math.floor(Math.random() * 10000000) }]);
    const [ imagesEmpresa, setImagesEmpresa ] = useState([]);
    const [ imagesFactura, setImagesFactura ] = useState([]);
    const [ isChangeImgE, setChangeImgE ] = useState(false);
    const [ isChangeImgF, setChangeImgF ] = useState(false);
    const [ isImgE, setImgE ] = useState(false);
    const [ isImgF, setImgF ] = useState(false);
    const [ openPhotoE, setOpenPhotoE ] = useState(false);
    const [ openPhotoF, setOpenPhotoF ] = useState(false);

    useEffect(()=>{
        if(isContinuoEdit){
            setOpenDialogEditInformacion(true);
            setContinuoEdit(false);
        }
    },[isContinuoEdit]);
    
    const handleSubDelete = ()=>{
        fetch('api/Empresas',{
            method:'DELETE',
            body: JSON.stringify({_id:rowInfo._id}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                handleDelete(rowInfo)            
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleAlert = ()=>{ setOpenDialog(true); };

    const handleAlertClose = ()=>{ setOpenDialog(false); };

    const handleClickEdit =  ()=>{
        setDatos(rowInfo);
        if(rowInfo.Bancos){
            if(rowInfo.Bancos.length > 0) setArrBancos(rowInfo.Bancos);
        }
        if(rowInfo.urlLogo){
            if(rowInfo.urlLogo !== ''){
                setImagesEmpresa([{data_url:rowInfo.urlLogo}]);
                setImgE(true);
            }
        }
        if(rowInfo.urlLogoFactura){
            if(rowInfo.urlLogoFactura !== ''){
                setImagesFactura([{data_url:rowInfo.urlLogoFactura}]);
                setImgF(true);
            }
        }
        setContinuoEdit(true);
    };

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.name]:e.target.value})};

    const handleAlertCloseEditInformacion = ()=>{
        setOpenDialogEditInformacion(false);
        setDatos({
            Direccion:'',
            EmailAdministrador:'',
            EmailFactura:'',
            EmailHost:'',
            EmailNotificaciones:'',
            EmailSoporte:'',
            EmailSSL:false,
            Empresa:'',
            Ruc:'',
            Telefono:''
        });
        setArrBancos([{ Banco:'', Tipo:'', Cuenta:'', idBanco:Math.floor(Math.random() * 10000000) }]);
    };

    const handleEditEquipo =()=>{
        const idImgEmpresa = isChangeImgE ? `${rowInfo.Empresa}_EMPRESA.${imagesEmpresa.length > 0 ? imagesEmpresa[0].file.name.split('.').pop().toString() : 'jpg'}` : rowInfo.urlLogo;
        const idImgFactura = isChangeImgF ? `${rowInfo.Empresa}_FACTURA.${imagesFactura.length > 0 ? imagesFactura[0].file.name.split('.').pop().toString() : 'jpg'}` : rowInfo.urlLogoFactura;
        setProcessing(true);
        const objeto = {...Datos};
            objeto.urlLogo = isChangeImgE ? imagesEmpresa.length > 0 ? `logos/${idImgEmpresa}` : '' : rowInfo.urlLogo;
            objeto.urlLogoFactura = isChangeImgF ? imagesFactura.length > 0 ? `logos/${idImgFactura}` : '' : rowInfo.urlLogoFactura;
            objeto.Bancos = [...arrBancos];
        fetch('api/Empresas',{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                if(isChangeImgE){
                    if(imagesEmpresa.length > 0){
                        const formD = new FormData();
                        formD.append('imagen',imagesEmpresa[0].file, idImgEmpresa);
                        fetch('/Empresas/LogoEmpresa',{method:'POST',body:formD})
                        .then(response => response.json())
                        .then(result => {             
                            if(result.message){
                                enqueueSnackbar(result.message, {variant:'success'});
                            }else{
                                console.error(result.status)
                                enqueueSnackbar(result.status, {variant:'error'});
                            }
                        });
                    }
                }
                if(isChangeImgF){
                    if(imagesFactura.length > 0){
                        const formD = new FormData();
                        formD.append('imagen',imagesFactura[0].file, idImgFactura);
                        fetch('/Empresas/LogoFactura',{method:'POST',body:formD})
                        .then(response => response.json())
                        .then(result => {             
                            if(result.message){
                                enqueueSnackbar(result.message, {variant:'success'});
                            }else{
                                console.error(result.status)
                                enqueueSnackbar(result.status, {variant:'error'});
                            }
                        });
                    }
                }
                handleUpdate(objeto);
                enqueueSnackbar(result.message, {variant:'success'}); 
                setTimeout(()=>{
                    setProcessing(false);
                },1000)      
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setProcessing(false);
            }
        });
    };

    const handleChange = (panel) => (event, isExpanded) => {setExpanded(isExpanded ? panel : false); };

    const handleSwitchSSL = (checked)=>{ setDatos({...Datos, EmailSSL:checked})};

    const handleBancos = useCallback((idBanco, elBanco)=>{
        const arrS = [...arrBancos];
        const arr = arrS.map(value=>{
            const objeto = {...value}
            if(value.idBanco === idBanco){
                return elBanco;
            }else{
                return objeto;
            }
        });
        setArrBancos(arr);
    },[arrBancos]);

    const handleCrearBanco = useCallback(()=>{
        setArrBancos([...arrBancos, { Banco:'', Tipo:'', Cuenta:'', idBanco:Math.floor(Math.random() * 10000000) }]);
    },[arrBancos]);
    
    const handleBorrarBanco = useCallback((idBanco)=>{
        const arrS = [...arrBancos];
        const filSubnet = arrS.filter(value=> value.idBanco !== idBanco);
        setArrBancos(filSubnet);
    },[arrBancos]);

    const BancoEl = arrBancos.map((value, index)=>(
        <ElementBanco 
            arrBancos={arrBancos}
            data={value} 
            handleBancos={handleBancos}
            handleCrearBanco={handleCrearBanco}
            handleBorrarBanco={handleBorrarBanco}
            idBanco={value.idBanco}  
            index={index} 
            key={value.idBanco} 
            total={arrBancos.length} 
        />
    ));

    const onChangeImageEmpresa = (imageList, addUpdateIndex) => {
        setChangeImgE(true);
        if(isImgE){
            setImgE(false);
            setImagesEmpresa(imageList);
            if(imageList.length === 0) setOpenPhotoE(true);
        }else{       
            setImagesEmpresa(imageList);
        }
        
    };

    const onChangeImageFactura = (imageList, addUpdateIndex) => {
        setChangeImgF(true);
        if(isImgF){
            setImgF(false);
            setImagesFactura(imageList);
            if(imageList.length === 0) setOpenPhotoF(true);
        }else{
            setImagesFactura(imageList);
        }
    };

    const handleDeleteLogoE = ()=>{
        fetch('/Empresas/Logos',{  
            method:'DELETE',
            body: JSON.stringify({nombreLogo:rowInfo.urlLogo}),
            headers:{
                'Content-Type': 'application/json'}
        })
        .then(response => response.json())
        .then(result => {             
            if(result.message){
                setOpenPhotoE(false);
                enqueueSnackbar(result.message, {variant:'success'});
            }else{
                console.error(result.status)
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleDeleteLogoF = ()=>{
        fetch('/Empresas/Logos',{  
            method:'DELETE',
            body: JSON.stringify({nombreLogo:rowInfo.urlLogoFactura}),
            headers:{
                'Content-Type': 'application/json'}
        })
        .then(response => response.json())
        .then(result => {             
            if(result.message){
                setOpenPhotoF(false);
                enqueueSnackbar(result.message, {variant:'success'});
            }else{
                console.error(result.status)
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleCancelarLogoE = ()=>{ setOpenPhotoE(false); };

    const handleCancelarLogoF = ()=>{ setOpenPhotoF(false); };

    return(
        <React.Fragment key={rowInfo.Mes}>
            <Dialog
                open={openPhotoE}
                onClose={handleCancelarLogoE}
                fullWidth
                maxWidth={'sm'}
                style={{padding:0}}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleCancelarLogoE}>
                    SE ELIMINARA EL LOGO DE LA BASE DE DATOS
                </DialogTitle>
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button onClick={handleDeleteLogoE} color="primary" variant='contained' style={{color:'#fff'}}>
                        PROCEDER
                    </Button>
                    <Button onClick={handleCancelarLogoE} color="default" variant='contained' style={{color:'#fff'}}>
                        CANCELAR
                    </Button>
                </DialogActions>
            </Dialog> 
            <Dialog
                open={openPhotoF}
                onClose={handleCancelarLogoF}
                fullWidth
                maxWidth={'sm'}
                style={{padding:0}}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleCancelarLogoF}>
                    SE ELIMINARA EL LOGO DE LA BASE DE DATOS
                </DialogTitle>
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button onClick={handleDeleteLogoF} color="primary" variant='contained' style={{color:'#fff'}}>
                        PROCEDER
                    </Button>
                    <Button onClick={handleCancelarLogoF} color="default" variant='contained' style={{color:'#fff'}}>
                        CANCELAR
                    </Button>
                </DialogActions>
            </Dialog> 
            <Dialog
                open={openDialog}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Desea Eliminar este Equipo"} </DialogTitle>
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button onClick={handleSubDelete} color="primary" variant='contained' style={{color:'#fff'}}>
                        Si
                    </Button>
                    <Button onClick={handleAlertClose} color="default" variant='contained' style={{color:'#fff'}}>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDialogEditInformacion}
                onClose={handleAlertCloseEditInformacion}
                maxWidth='md'
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseEditInformacion}>
                    < Chip
                        avatar={<Avatar>< ApartmentIcon fontSize='small'/></Avatar>}
                        color='secondary'
                        label='Informacion de Empresa'  
                    />
                </DialogTitle>
                <DialogContent >
                    <Grid container justifyContent='flex-start' alignItems='flex-start' spacing={1} style={{minHeight:500, height:500}} >
                        <Grid item xs={12} >
                            {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:6}}></div>}
                        </Grid>     
                        <Grid item xs={12} >         
                            <Paper elevation={2} >
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><ImportantDevicesIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='Informacion General'  
                                        />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.Empresa || ''}
                                                    name='Empresa'
                                                    onChange={handleDatos}
                                                    label='Empresa'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>   
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.Ruc || ''}
                                                    name='Ruc'
                                                    onChange={handleDatos}
                                                    label='RUC'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>  
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.Telefono || ''}
                                                    name='Telefono'
                                                    onChange={handleDatos}
                                                    label='Telefono'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>     
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PaginaWeb || ''}
                                                    name='PaginaWeb'
                                                    onChange={handleDatos}
                                                    label='PaginaWeb'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.Direccion || ''}
                                                    name='Direccion'
                                                    onChange={handleDatos}
                                                    label='Direccion'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.Coordenadas || ''}
                                                    name='Coordenadas'
                                                    onChange={handleDatos}
                                                    label='Coordenadas'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                    <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><MarkunreadMailboxIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='Correos'  
                                        />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailAdministrador || ''}
                                                    name='EmailAdministrador'
                                                    onChange={handleDatos}
                                                    label='EmailAdministrador'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailHost || ''}
                                                    name='EmailHost'
                                                    onChange={handleDatos}
                                                    label='EmailHost'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailPuerto || ''}
                                                    name='EmailPuerto'
                                                    onChange={handleDatos}
                                                    label='EmailPuerto'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'   
                                                    type='Number'                          
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center', height:55 }}>
                                                <TooltipAntd title="SSL" color='BLUE' >
                                                    <SwitchAntd checkedChildren="SSL ON" unCheckedChildren="SSL OFF" checked={Datos.EmailSSL} onChange={handleSwitchSSL} />
                                                </TooltipAntd>  
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailBackups || ''}
                                                    name='EmailBackups'
                                                    onChange={handleDatos}
                                                    label='Email Backups'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassBackups || ''}
                                                    name='PassBackups'
                                                    onChange={handleDatos}
                                                    label='Pass Backups'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>  
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailFactura || ''}
                                                    name='EmailFactura'
                                                    onChange={handleDatos}
                                                    label='EmailFactura'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassFactura || ''}
                                                    name='PassFactura'
                                                    onChange={handleDatos}
                                                    label='PassFactura'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>  
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailNotificaciones || ''}
                                                    name='EmailNotificaciones'
                                                    onChange={handleDatos}
                                                    label='EmailNotificaciones'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassNotificaciones || ''}
                                                    name='PassNotificaciones'
                                                    onChange={handleDatos}
                                                    label='PassNotificaciones'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailPagos || ''}
                                                    name='EmailPagos'
                                                    onChange={handleDatos}
                                                    label='EmailPagos'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassPagos || ''}
                                                    name='PassPagos'
                                                    onChange={handleDatos}
                                                    label='PassPagos'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailInfo || ''}
                                                    name='EmailInfo'
                                                    onChange={handleDatos}
                                                    label='EmailInfo'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassInfo || ''}
                                                    name='PassInfo'
                                                    onChange={handleDatos}
                                                    label='PassInfo'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailProformas || ''}
                                                    name='EmailProformas'
                                                    onChange={handleDatos}
                                                    label='EmailProformas'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassProformas || ''}
                                                    name='PassProformas'
                                                    onChange={handleDatos}
                                                    label='PassProformas'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.EmailSoporte || ''}
                                                    name='EmailSoporte'
                                                    onChange={handleDatos}
                                                    label='EmailSoporte'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.PassSoporte || ''}
                                                    name='PassSoporte'
                                                    onChange={handleDatos}
                                                    label='PassSoporte'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                    <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><LabelImportantIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='Twilio'  
                                        />
                                        <Typography className={classes.secondaryHeading}>Envio de SMS</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.TwilioSID || ''}
                                                    name='TwilioSID'
                                                    onChange={handleDatos}
                                                    label='TwilioSID'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.TwilioTOKEN || ''}
                                                    name='TwilioTOKEN'
                                                    onChange={handleDatos}
                                                    label='TwilioTOKEN'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                    <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel4bh-content"
                                    id="panel4bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><PaletteIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='Colores'  
                                        />
                                    <Typography className={classes.secondaryHeading}>Colores en Hexadecimal</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.ColorPrimary || ''}
                                                    name='ColorPrimary'
                                                    onChange={handleDatos}
                                                    label='ColorPrimary'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid> 
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    value={Datos.ColorSecondary || ''}
                                                    name='ColorSecondary'
                                                    onChange={handleDatos}
                                                    label='ColorSecondary'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined'                             
                                                />
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion> 
                                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                                    <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel5bh-content"
                                    id="panel5bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><WallpaperIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='Logos'  
                                        />
                                    <Typography className={classes.secondaryHeading}>Logos de Empresa</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                            <Grid item sm={6} xs={12}>
                                                <div className="App">
                                                    <ImageUploading
                                                        multiple
                                                        value={imagesEmpresa}
                                                        onChange={onChangeImageEmpresa}
                                                        maxNumber={1}
                                                        dataURLKey="data_url"
                                                    >
                                                        {({
                                                        imageList,
                                                        onImageUpload,
                                                        onImageRemoveAll,
                                                        onImageUpdate,
                                                        onImageRemove,
                                                        isDragging,
                                                        dragProps,
                                                        }) => (
                                                        // write your building UI
                                                        <Grid container justifyContent='center' spacing={2}>
                                                            <Grid item xs={5}>
                                                                < Chip 
                                                                    color='default'
                                                                    label='LOGO EMPRESA'  
                                                                />
                                                            </Grid>
                                                            <Grid item xs={9}>
                                                                <Button 
                                                                    variant="contained" 
                                                                    color="secondary"
                                                                    fullWidth
                                                                    size='large'
                                                                    disabled={isImgE}
                                                                    style={isDragging ? { color: 'red' } : undefined}
                                                                    onClick={onImageUpload}
                                                                    {...dragProps}
                                                                >
                                                                    Click or Drop here
                                                                </Button>
                                                            </Grid>
                                                            <Grid item xs={9}>
                                                                {imageList.map((image, index) => (
                                                                    <Grid container alignItems='center' justifyContent='center' key={index} direction='column'>
                                                                        <Grid item>
                                                                            <img src={image['data_url']} alt="" width="100" key={Date.now()}/>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Grid container justifyContent='center'>
                                                                                <Grid item>
                                                                                    <IconButton
                                                                                        onClick={() => onImageRemove(index)}
                                                                                        size='small'
                                                                                        color='secondary'
                                                                                        style={{color:"red"}}
                                                                                    >
                                                                                        <DeleteIcon/>
                                                                                    </IconButton>
                                                                                </Grid>
                                                                            </Grid>                                                             
                                                                        </Grid>
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        </Grid>
                                                        )}
                                                    </ImageUploading>
                                                </div>
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <div className="App">
                                                    <ImageUploading
                                                        multiple
                                                        value={imagesFactura}
                                                        onChange={onChangeImageFactura}
                                                        maxNumber={1}
                                                        dataURLKey="data_url"
                                                    >
                                                        {({
                                                        imageList,
                                                        onImageUpload,
                                                        onImageRemoveAll,
                                                        onImageUpdate,
                                                        onImageRemove,
                                                        isDragging,
                                                        dragProps,
                                                        }) => (
                                                        // write your building UI
                                                        <Grid container justifyContent='center' spacing={2}>
                                                            <Grid item xs={5}>
                                                                < Chip 
                                                                    color='default'
                                                                    label='LOGO FACTURA'  
                                                                />
                                                            </Grid>
                                                            <Grid item xs={9}>
                                                                <Button 
                                                                    variant="contained" 
                                                                    color="secondary"
                                                                    fullWidth
                                                                    disabled={isImgF}
                                                                    size='large'
                                                                    style={isDragging ? { color: 'red' } : undefined}
                                                                    onClick={onImageUpload}
                                                                    {...dragProps}
                                                                >
                                                                    Click or Drop here
                                                                </Button>
                                                            </Grid>
                                                            <Grid item xs={9}>
                                                                {imageList.map((image, index) => (
                                                                    <Grid container alignItems='center' justifyContent='center' key={index} direction='column'>
                                                                        <Grid item>
                                                                            <img src={image['data_url']} alt="" width="100" key={Date.now()}/>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Grid container justifyContent='center'>
                                                                                <Grid item>
                                                                                    <IconButton
                                                                                        onClick={() => onImageRemove(index)}
                                                                                        size='small'
                                                                                        color='secondary'
                                                                                        style={{color:"red"}}
                                                                                    >
                                                                                        <DeleteIcon/>
                                                                                    </IconButton>
                                                                                </Grid>
                                                                            </Grid>                                                             
                                                                        </Grid>
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        </Grid>
                                                        )}
                                                    </ImageUploading>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>                   
                                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel6bh-content"
                                        id="panel6bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><AccountBalanceIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='Bancos'  
                                        />
                                    <Typography className={classes.secondaryHeading}>Cuentas Bancarias</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                        {  BancoEl }
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                                    <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel7bh-content"
                                    id="panel7bh-header"
                                    >
                                        < Chip 
                                            avatar={<Avatar><DraftsIcon fontSize='small'/></Avatar>}
                                            color='primary'
                                            label='E-Mails'  
                                        />
                                    <Typography className={classes.secondaryHeading}>Plantillas de E-mails</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={Datos.EmailBienvenida || ''}
                                                    name='EmailBienvenida'
                                                    onChange={handleDatos}
                                                    label='Correo de Bienvenida'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined' 
                                                    multiline     
                                                    maxRows={10}                       
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Alert severity="info">1:Nombres de Cliente = ${`{Nombres}`} || 2:Mes = ${`{MesServicio}`}</Alert>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={Datos.EmailPagosPlantilla || ''}
                                                    name='EmailPagosPlantilla'
                                                    onChange={handleDatos}
                                                    label='Correo de Pagos'
                                                    fullWidth
                                                    size='small'
                                                    variant='outlined' 
                                                    multiline     
                                                    maxRows={10}                       
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Alert severity="info">Nombres de Cliente = ${`{Nombres}`}</Alert>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={Datos.EmailInstalacionesPagadas || ''}
                                                    name='EmailInstalacionesPagadas'
                                                    onChange={handleDatos}
                                                    label='Instalacion Pagada Completa'
                                                    fullWidth
                                                    variant='outlined' 
                                                    multiline     
                                                    maxRows={10}                       
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                            <Grid item xs={12}>
                                            <Alert severity="info">1:Nombres de Cliente = ${`{Nombres}`} || 2:Valor de Abono = ${`{ValAbono}`}</Alert>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={Datos.EmailInstalacionesAbonadas || ''}
                                                    name='EmailInstalacionesAbonadas'
                                                    onChange={handleDatos}
                                                    label='Abono de Instalacion'
                                                    fullWidth
                                                    variant='outlined' 
                                                    multiline     
                                                    maxRows={10}                       
                                                />
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion> 
                            </Paper>   
                        </Grid> 
                    </Grid>
                    
                </DialogContent> 
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    
                    <Button size='large' color='primary' startIcon={<SaveIcon/>} variant='contained' onClick={handleEditEquipo} disabled={isProcessing} >
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Guardar'}
                    </Button>
                    <Button size='large' color='secondary' variant='contained' onClick={handleAlertCloseEditInformacion} disabled={isProcessing}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>  
            <TrYounetStyled >
                {
                    columns.map((el,index)=>
                        index === 0 ? 
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            <Grid container>
                                <Grid item>
                            
                                    <Tooltip title='EDIT' placement="top" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={handleClickEdit} disabled={openDialogEditInformacion}>
                                            <EditIcon style={{color:'green'}}/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='ELIMINAR' placement="top" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={handleAlert}>
                                            <DeleteIcon style={{color:'red'}}/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </TdYounetStyled> : index === 1 ? 
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Empresa}
                        </TdYounetStyled> : index === 2 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Ruc}
                        </TdYounetStyled> : index === 3 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Telefono}
                        </TdYounetStyled> : index === 4 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Direccion}
                        </TdYounetStyled> : index === 5 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.EmailAdministrador}
                        </TdYounetStyled> : index === 6 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.PaginaWeb}
                        </TdYounetStyled> : index === 7 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.EmailSoporte}
                        </TdYounetStyled> : 
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.EmailInfo}
                        </TdYounetStyled> 
                    )
                }
            </TrYounetStyled>
        </React.Fragment>
    );
};

const ElementBanco = memo((props)=>{
    const { index, data, total, idBanco, handleBorrarBanco, handleCrearBanco, arrBancos, handleBancos } = props;
    const [ Datos, setDatos ] = useState({Banco:'', Tipo:'', Cuenta:'', idBanco});

    useEffect(()=>{
        setDatos(data);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    let cantItem = index + 1;
  
    const handleSubBorrarBanco = ()=>{ handleBorrarBanco(idBanco); };

    const handleDatos = ({target})=>{ setDatos({...Datos, [target.id]:target.value}); };

    const handleDatosSelect = ({target})=>{ setDatos({...Datos, Tipo:target.value}); };

    const handleSubSubnetBanco = ({target})=>{
        const objeto = {...Datos};
        objeto.Banco = target.value;
        handleBancos(idBanco, objeto);
    };

    const handleSubSubnetTipo = ({target})=>{
        const objeto = {...Datos};
        objeto.Tipo = target.value;
        handleBancos(idBanco, objeto);
    };

    const handleSubSubnetCuenta = ({target})=>{
        const objeto = {...Datos};
        objeto.Cuenta = target.value;
        handleBancos(idBanco, objeto);
    };

    if(arrBancos.length === 1){
        return(
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >  
                <Paper elevation={2} style={{padding:10}} square >
                    <Grid container justifyContent='flex-start' spacing={2}>
                        <Grid item  md={8} xs={12}>
                            <TextField
                                value={Datos.Banco || ''}
                                id='Banco'
                                onChange={handleDatos}
                                label='Banco'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetBanco}                           
                            />
                        </Grid>  
                        <Grid item md={4} xs={12}>
                            <TextField
                                value={Datos.Tipo || ''}
                                id='Tipo'
                                onChange={handleDatosSelect}
                                label='Tipo'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetTipo}      
                                select                     
                            >
                                <MenuItem value='Ahorros'>Ahorros</MenuItem>
                                <MenuItem value='Corriente'>Corriente</MenuItem>
                            </TextField>
                        </Grid>    
                        <Grid item md={8} xs={10}>
                            <TextField
                                value={Datos.Cuenta || ''}
                                id='Cuenta'
                                onChange={handleDatos}
                                label='Cuenta'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetCuenta}                           
                            />
                        </Grid>                 
                        <Grid item xs={2}>
                            <IconButton onClick={handleCrearBanco} style={{position:'relative', top:-3, left:-12}}>
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>         
                </Paper>
            </Grid>             
        );
    }else{
        return(         
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Paper elevation={2} style={{padding:10}} square>
                    <Grid container justifyContent='flex-start' spacing={2} >
                        <Grid item md={8} xs={12} >
                            <TextField
                                value={Datos.Banco || ''}
                                id='Banco'
                                onChange={handleDatos}
                                label='Banco'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetBanco}                           
                            />
                        </Grid>  
                        <Grid item md={4} xs={12} >
                        <TextField
                                value={Datos.Tipo || ''}
                                id='Tipo'
                                onChange={handleDatosSelect}
                                label='Tipo'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetTipo}      
                                select                     
                            >
                                <MenuItem value='Ahorros'>Ahorros</MenuItem>
                                <MenuItem value='Corriente'>Corriente</MenuItem>
                            </TextField>
                        </Grid>    
                        <Grid item md={8} xs={10} >
                            <TextField
                                value={Datos.Cuenta || ''}
                                id='Cuenta'
                                onChange={handleDatos}
                                label='Cuenta'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetCuenta}                           
                            />
                        </Grid>    
                        <Grid item xs={2}>
                            { cantItem === total && 
                            <React.Fragment >
                                <IconButton onClick={handleCrearBanco} size='small' style={{position:'relative', top:5}}      >
                                    <AddCircleOutlineIcon color='primary'/>
                                </IconButton>
                                <IconButton onClick={handleSubBorrarBanco} size='small' style={{position:'relative', top:5}}      >
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </React.Fragment>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>   
        );
    }
    
});

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
};
  
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead >
        <TableRow style={{display:'flex'}}>
          {columns.map((headCell) => (
            <TheadYounet  
                headCells={columns} 
                key={headCell.id} 
                widthDefault={headCell.minWidth} 
                createSortHandler={createSortHandler} 
                order={order} 
                orderBy={orderBy} 
                headCell={headCell} 
                classes={classes} 
                align={headCell.align}
            />
          ))}
        </TableRow>
      </TableHead>
    );
};

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

const ListadoEquipo = memo(({data, handleDelete, handleUpdate, dataZona, ModelosList, Marcas, Tipos})=>{
    const size = useWindowSize();
    const [ order, setOrder] = useState('asc');
    const [ orderBy, setOrderBy] = useState('Empresa');
    const classes = styles();
    const [ page, setPage] = useState(0);
    const [ rowsPerPage, setRowsPerPage] = useState(8);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return( 
        <div style={{ maxWidth: '100%', minWidth:'100%', marginTop:2, overflowX:'auto'}}>
            <TableContainer >
                <Table aria-label="sticky table" size='small' style={{height:size.height === undefined ? 500 : size.height - 220, position:'sticky', top:0}}>
                <Scrollbars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                >
                <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={data.length}
                    />
                <TableBody >
                {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => <RowEmpresa key={`${row._id}-${index}`} rowInfo={row} handleDelete={handleDelete} handleUpdate={handleUpdate} dataZona={dataZona} Tipos={Tipos} Marcas={Marcas} ModelosList={ModelosList}/> )}
                </TableBody>
                </Scrollbars>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage='Filas'
            />
        </div>
        
    )

});

const ListadoEquipos= ({data, handleProcess, handleUpdate, handleDelete, dataZona })=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
          <ListadoEquipo data={data} handleProcess={handleProcess} handleUpdate={handleUpdate} handleDelete={handleDelete} dataZona={dataZona} />
        </SnackbarProvider>
    );
};


export default ListadoEquipos;